import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AreaCenter } from 'src/app/interfaces/area-center';
import { AreaCenterService } from 'src/app/services/area-center.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from 'src/app/services/error.service';

//fk
import { AreaService } from 'src/app/services/area.service';
import { CenterService } from 'src/app/services/center.service';
import { Center } from 'src/app/interfaces/center';
import { Area } from 'src/app/interfaces/area';
import { Turn } from 'src/app/interfaces/turn';
import { TurnService } from 'src/app/services/turn.service';

@Component({
  selector: 'app-add-edit-area-center',
  templateUrl: './add-edit-area-center.component.html',
  styleUrls: ['./add-edit-area-center.component.css']
})
export class AddEditAreaCenterComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';
  idUserAreaCenter: number=0;
  idcenter: number=0;

  centers: Center[] = [];
  areas: Area[] = [];
  turns: Turn[] = [];
  selectedCenter: Center | null = null;
  selectedArea: Area | null = null;
  selectedTurn: Turn | null = null;

  constructor(private fb: FormBuilder,
    private _areacenterService: AreaCenterService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute,
    private _areaService: AreaService,
    private _centerService: CenterService,
    private _turnService: TurnService,
    private _errorService: ErrorService
    ) {
    this.form = this.fb.group({
      /*namearea: ['', Validators.required],
      lastnamearea: ['', Validators.required],
      ci: ['', Validators.required],
      namecenter: ['', Validators.required],*/
      idarea: ['', Validators.required],
      idcenter: ['', Validators.required],
      idturn: ['', Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    // Obtener la lista de centros
    this._centerService.getListCenters().subscribe((centers: Center[]) => {
      this.centers = centers;
    }, (error) => {
      console.error('Error al obtener las carreras:', error);
    });

    // Obtener la lista de areas
    this._areaService.getListAreas().subscribe((areas: Area[]) => {
      this.areas = areas;
    }, (error) => {
      console.error('Error al obtener las areas:', error);
    });
    // Obtener la lista de turnos
    this._turnService.getListTurns().subscribe((turns: Turn[]) => {
      this.turns = turns;
    }, (error) => {
      console.error('Error al obtener los turnos:', error);
    });

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getAreaCenter(this.id);
    }
  }

  /*getAreaCenter(id: number) {
    this.loading = true;
    this._areacenterService.getAreaCenter(id).subscribe((data: AreaCenter) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
        lastname: data.lastname,
        ci: data.ci,
        email: data.userid
      })
    })
  }*/
  selectCenter(center: Center) {
    this.selectedCenter = center;
    this.form.patchValue({
      idcenter: center.id
    });
  }

  selectArea(area: Area) {
    this.selectedArea = area;
    this.form.patchValue({
      idarea: area.id
    });
  }

  selectTurn(turn: Turn) {
    this.selectedTurn = turn;
    this.form.patchValue({
      idturn: turn.id
    });
  }

  getAreaCenter(id: number) {
    this.loading = true;
    this._areacenterService.getAreaCenter(id).subscribe((data: AreaCenter) => {
      this.loading = false;
      //obtener carrera
      if (data.idcenter !== undefined) {
        this._centerService.getCenter(data.idcenter).subscribe((data2: Center) => {
          this.loading = false;
          //console.log("valores de Center: "+data2.id);
          this.form.patchValue({
            idcenter: data2.id
          });
        })
      } else {
        console.error('El ID de centro es undefined.');
      }

      //obtener estudiante
      if (data.idarea !== undefined) {
        //console.log("user.email: "+data.userid)
        this._areaService.getArea(data.idarea).subscribe((area: Area) => {
          //console.log("area.id: "+area.id);
          this.form.patchValue({
            idarea: area.id
          });
        }, (error) => {
          console.error('Error al obtener el area de centro:', error);
        });
      } else {
        console.error('El ID de area es undefined.');
      }

      //obtener turno
      if (data.idturn !== undefined) {
        //console.log("user.email: "+data.userid)
        this._turnService.getTurn(data.idturn).subscribe((turn: Turn) => {
          //console.log("area.id: "+area.id);
          this.form.patchValue({
            idarea: turn.id
          });
        }, (error) => {
          console.error('Error al obtener el turno de centro:', error);
        });
      } else {
        console.error('El ID de turno es undefined.');
      }
    });
  }
  
  
  
  addAreaCenter() {
    let areacenter: AreaCenter = {
      idarea: this.form.value.idarea,
      idcenter: this.form.value.idcenter,
      idturn: this.form.value.idturn,
      state: 1
    };

    /*if (!this.isEmail(this.form.value.email)) {
      console.log("Email: " + this.form.value.email);
      this.toastr.error('El campo email campo debe ser un correo electrónico', 'Error');
      return;
    }*/

    /*let pass: string;
    pass = Math.floor(1000 + Math.random() * 9000).toString();
    this.addUserParams(this.form.value.email, pass, 2);*/
    //console.log("valores enviados areacenter id area: "+areacenter.idarea+", idcenter: "+areacenter.idcenter);
    this.saveOrUpdateAreaCenter(areacenter);
    /*
    this._userService.getLastUser().subscribe(
      (user: User) => {
        this.lastUser = user;
        this.idUserAreaCenter = this.lastUser?.id != null ? this.lastUser.id + 1 : 0;
        console.log('Último usuario:', this.lastUser.id);
        areacenter.userid = this.idUserAreaCenter; // Actualizamos userid con el valor obtenido
        this.saveOrUpdateAreaCenter(areacenter);
      },
      (error) => {
        console.error('Error al obtener el último usuario:', error);
      }
    );*/
}

saveOrUpdateAreaCenter(areacenter: AreaCenter) {
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
    //  console.log("Editando: " + areacenter);
      areacenter.id = this.id;
      this._areacenterService.updateAreaCenter(this.id, areacenter).subscribe(() => {
        this.toastr.info(`La adición de area al centro: ${areacenter.namearea} fue actualizada con exito`, 'Adicíon area-centro actualizada');
        this.loading = false;
        this.router.navigate(['/areacenter']);
      });

    } else {
      // Es agregar
     // console.log("Agregando: " + areacenter);
      this._areacenterService.saveAreaCenter(areacenter).subscribe(() => {
        this.toastr.success(`El area ${areacenter.namearea} fue agregada con exito`, 'Area-centro registrados');
        this.loading = false;
        this.router.navigate(['/areacenter']);
      });
    }
}
  
  /*addUserParams(email:string, password:string, rol:number) {
    //Validamos que el username sea un correo
    if (!this.isEmail(email)) {
      this.toastr.error('El primer campo debe ser un correo electrónico', 'Error');
      return;
    }
    // Validamos que el usuario ingrese valores
    if (email == '' || password == '') {
      this.toastr.error('Todos los campos son obligatorios', 'Error');
      return;
    }
    // Creamos el objeto
    const user: User = {
      username: email,
      password: password,
      rol: rol
    }
    this.loading = true;
    this._userService.signIn(user).subscribe({
      next: (v) => {
        this.loading = false;
        this.toastr.success(`El usuario ${email} fue registrado con exito`, 'Usuario registrado');
        //this.router.navigate(['/login']);

        // Aquí puedes acceder a los valores del usuario
        const id = v.id;
        const email2 = v.email;
        // Realiza las acciones necesarias con los valores del usuario
        //console.log("Usuario id: "+id+ ", email: "+email2); 
        
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
        this._errorService.msjError(e);
      }
    })
    
  }
  generateRandomNumber(): number {
    return Math.floor(1000 + Math.random() * 9000);
  }
  isEmail(email: string): boolean {
    // Expresión regular para validar un correo electrónico
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }*/
}

